import Viewership from './components/Viewership.vue'

export default Viewership



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/viewership/index.js